import { FC } from 'react';
import { useTranslation } from 'react-i18next';

import { IconButton } from '@components/base';
import { ImageType } from '@models/Image';

import useDownloadImage from './useDownloadImage';

export type DownloadImageButtonProps = {
  fileNameBase: string;
  imageType: ImageType;
  src: string;
};

const DownloadImageButton: FC<DownloadImageButtonProps> = ({ fileNameBase, imageType, src }) => {
  const { t } = useTranslation();
  const { downloadImage, loading } = useDownloadImage(fileNameBase, imageType, src);

  return (
    <IconButton
      icon='download'
      loading={loading}
      onClick={downloadImage}
      title={t('images.download', { context: imageType })}
    />
  );
};

export default DownloadImageButton;
